import { requester } from 'App';
import P from 'components/P';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import { useEffect, useState } from 'react';
import VendorSaleList from 'routes/vendorRe/components/VendorSaleList';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import downChev from 'routes/vendorRe/images/down_chevron.png';
import styles from './StoreSettlementBest.module.css';
import {
    commonFontWeight700,
    contentStart,
    infoFontSize1
} from './commonConst';
import Dummy from 'components/Dummy';
import { useNavigate } from 'react-router-dom';

const StoreSettlementBest = (props) => {
    const { storeId } = props;
    const navigate = useNavigate();
    const [isMounted, setMounted] = useState(false);
    const [weekSalesData, setWeekSalesData] = useState([]);
    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        if (isMounted) {
            let storeData = { id: storeId }
            requester.getStoreBestSalesTop3(storeData, result => {
                console.log(storeData)
                console.log(result.data)
                setWeekSalesData(result.data);
                console.log("getStoreBestSalesTop3",result.data)

            });


        }
    }, [isMounted]);
    const onDetailClick = () => {
        navigate(`/vendor/store/sale/${storeId}`, { state: { storeName: props.storeName } });
    }
    return (
        <VerticalFlex>
            <FlexChild alignItems={contentStart}>
                <VerticalFlex
                    backgroundColor="#fff"
                    borderRadius="1em"
                    padding="1.5em"
                >
                    <FlexChild>
                        <VerticalFlex height="auto">
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild width={'initial'}>
                                        <P
                                            size={"min(4.2vw, 25px)"}
                                            weight={commonFontWeight700}
                                        >
                                            주간 판매량 BEST 3
                                        </P>
                                    </FlexChild>
                                    <FlexChild>
                                        <div style={{ cursor: "pointer", display: "flex", justifyContent: "flex-end", gap: "5px" }}>
                                            {/* <P onClick={onDetailClick} size={"min(3.2vw, 16px)"}>상세보기</P> */}
                                            {/* <img
                                                className={styles.chev}
                                                src={downChev}
                                                alt="아래 방향"
                                            /> */}
                                        </div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            {/* 반복 구간 시작*/}
                            {weekSalesData.length > 0 && weekSalesData ? (
                                <FlexChild>
                                    <HorizontalFlex justifyContent="flex-start" gap={15}>
                                        {weekSalesData
                                            .sort((a, b) => b.quantity - a.quantity)
                                            .map((saleItem, index) => (
                                                <VendorSaleList
                                                    key={index}
                                                    data={saleItem}
                                                />
                                            )
                                            )}
                                    </HorizontalFlex>
                                </FlexChild>
                            )
                                :
                                (
                                    <FlexChild padding={"21%"}>
                                        <P size={"min(2rem, 22px)"} color={"#D9D9D9"}>데이터가 없습니다.</P>
                                    </FlexChild>
                                )
                            }
                            {/* 반복 구간 끝 */}
                        </VerticalFlex>
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
        </VerticalFlex>
    );
};

export default StoreSettlementBest;
